import { DocumentNode } from "graphql";

export interface StoreItem {
  id: string;
  name: string;
}

export interface StoreItemInput {
  entity: StoreItemEntity;
  input?: object;
  mutation: DocumentNode;
  isInput: boolean;
}

export interface StoreItemDeleteInput {
  entity: StoreItemEntity;
  id: string;
  input: object;
  mutation: DocumentNode;
}

export interface StoreItemFiltering {
  filtering: object;
  isNotFiltering?: boolean;
  query: DocumentNode;
  entity: StoreItemEntity;
  fetchPolicy?: 'standby' | 'cache-first' | 'network-only' | 'no-cache' | 'cache-only';
}


export enum StoreItemEntity {
  currency = 'currency',
  language = 'language',
  unitOfMeasurement = 'unitOfMeasurement',
  paymentMode = 'paymentMode',
  user = 'user',
  userRole = 'userRole',
  device = 'device',
  warehouse = 'warehouse',
  warehouseDetails = 'warehouseDetails',
  zone = 'zone',
  buildings = 'buildings',
  itemDashboard = 'itemDashboard',
  permissions = 'permissions',
  password = 'password',
  geographicalZones = 'geographicalZones',
  warehouseAssignee = 'warehouseAssignee',
  alertDashboard = 'alertDashboard',
  binAlertConfiguration = 'binAlertConfiguration',
  warehouseSensor = 'warehouseSensor',
  sensorBinCoverage = 'sensorBinCoverage',
  district = 'district',
  ward = 'ward',
  zoneBinCoverage = 'zoneBinCoverage',
  zoneBins = 'zoneBins',
  assigneeWarehouses = 'assigneeWarehouses',
  faqs = 'faqs',
  alertData = 'alertData',
  sensorAlertConfig = 'sensorAlertConfig',
  generalWarehouseReadingsDashboard = 'generalWarehouseReadingsDashboard',
  generalZoneReadingsDashboard = 'generalZoneReadingsDashboard',
  zoneDashboardReadings = "zoneDashboardReadings",
  warehouseAlertCount = "warehouseAlertCount",
  pagination = "pagination"
}
